import React from 'react';
import PropTypes from 'prop-types';

import Linkage from '../../common/Linkage';

function ColumnGenre({ width, item, style }) {
  return (
    <div className={`track-genre`} style={{ width, zIndex: 50, ...style}}>
      {item.genre && <Linkage label={item.genre.name} to={`/genres/${item.genre.slug}/featured`} linkClassName={`link-enable`} />}
    </div>
  )
}

ColumnGenre.propTypes = {
  width: PropTypes.number.isRequired,
  item: PropTypes.object.isRequired,
  style: PropTypes.object,
}

export default ColumnGenre;
